import React from 'react';

const GraphicsSearchPageHeader = () => {
  return (
    <header className="mx-auto w-full px-24 text-center">
      <h1 className="m-0 px-32 font-suisse-screen text-headline-lg md:text-headline-alt-lg">
        Charts and Data Library
      </h1>
      <h2 className="mx-auto mb-0 mt-8 max-w-[570px] font-suisse-neue text-body-md font-normal lg:max-w-[630px] lg:text-body-lg">
        Data visualizations, maps, tables, charts, and other visual journalism from The Information.
      </h2>
    </header>
  );
};

export default GraphicsSearchPageHeader;
